import { TableConfig } from 'commons/types/tableConfig.interface';

export const config: TableConfig = [
  {
    header: 'Bin',
    key: 'bin',
  },
  {
    header: 'QTY',
    key: 'quantity',
  },
];
